module.exports = __webpack_public_path__ + "img/img_32389_0_148.f90b3960.png";